import { isArray } from 'lodash';

import { ModuleSettings } from './module-settings.do';

/**
 * Structure for holding a list of recent object property values.
 * It has no associated value schema on the Back End.
 */
export class RecentObjectsSettings extends ModuleSettings {
  /**
   * The list of recent object property values indexed by the organization id.
   *
   * The same user can have different recent objects for each organization.
   */
  public valuesByOrganization: Record<string, string[]> = {};

  /** @deprecated use RecentObjectsSettings.valuesByOrganization */
  public get idsByOrganizationId(): Record<string, string[]> {
    return this.valuesByOrganization;
  }

  /** @deprecated use RecentObjectsSettings.valuesByOrganization */
  public set idsByOrganizationId(record: Record<string, string[]>) {
    this.valuesByOrganization = record;
  }

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor() {
    super();
  }

  /** @deprecated use RecentObjectsSettings.getValues() */
  public get(organizationId: string): string[] {
    return this.getValues(organizationId);
  }

  /** @deprecated use RecentObjectsSettings.setValues() */
  public set(organizationId: string, values: string[]): void {
    this.setValues(organizationId, values);
  }

  public getValues(organizationId: string): string[] {
    let values = this.valuesByOrganization[organizationId];
    if (!isArray(values)) {
      return [];
    }
    return values;
  }

  public setValues(organizationId: string, values: string[]): void {
    this.valuesByOrganization[organizationId] = values;
  }
}
